// Helpers shared by the SMS setup page (/s/setup/:code) and the emailed
// reset/invitation page (/auth/reset-password). Setup tokens stay in component
// memory only: never put them in localStorage/sessionStorage or log them.

export const SETUP_CODE_PATTERN = /^[A-Za-z0-9_-]{22}$/;
export const MIN_PASSWORD_LENGTH = 8;

// HttpService rejects with the response body: { errors: [{ code, detail }] },
// { error }, or { message } depending on the endpoint.
export function apiErrorMessage(value, fallback) {
  if (!value || typeof value !== "object") return fallback;
  if (Array.isArray(value.errors)) {
    const first = value.errors.find((error) => typeof error?.detail === "string");
    if (first) return first.detail;
    const plain = value.errors.find((error) => typeof error === "string");
    if (plain) return plain;
  }
  if (typeof value.error === "string") return value.error;
  if (typeof value.message === "string" && value.message !== "Network Error") return value.message;
  return fallback;
}

export function apiErrorCode(value) {
  if (!value || typeof value !== "object" || !Array.isArray(value.errors)) return null;
  return value.errors.find((error) => typeof error?.code === "string")?.code || null;
}

export function passwordProblem(password, confirmation) {
  if (password.length < MIN_PASSWORD_LENGTH) {
    return `Use at least ${MIN_PASSWORD_LENGTH} characters.`;
  }
  if (password !== confirmation) return "The passwords do not match.";
  return "";
}

export function isSession(value) {
  return Boolean(value) && typeof value === "object" &&
    typeof value.access_token === "string" && typeof value.refresh_token === "string";
}

export function isSetup(value) {
  return Boolean(value) && typeof value === "object" &&
    typeof value.token === "string" && typeof value.email === "string";
}

export const setupPayload = ({ token, email }, password, confirmation) => ({
  data: {
    type: "password-reset",
    attributes: { token, email, password, password_confirmation: confirmation },
  },
});
